import React from "react";
import { motion } from "framer-motion";
import { Building2, Store, Factory, Warehouse, ClipboardList, PenTool, ArrowUpRight } from "lucide-react";
import { useI18n } from "../i18n";

const Services = () => {
  const { t } = useI18n();

  const items = [
    { Icon: Building2, ...t.services.konut, num: "01", filter: { category: "Konut" } },
    { Icon: Store, ...t.services.ticari, num: "02", filter: { category: "Ticari" } },
    { Icon: Factory, ...t.services.fabrika, num: "03", filter: { category: "Fabrika" } },
    { Icon: Warehouse, ...t.services.lojistik, num: "04", filter: { category: "Lojistik" } },
    { Icon: ClipboardList, ...t.services.danismanlik, num: "05", filter: { category: "Proje Danışmanlıkları" } },
    { Icon: PenTool, ...t.services.mimari, num: "06", filter: { category: "Mimari Tasarım & Dekorasyon" } },
  ];

  const onCardClick = (filter) => {
    window.dispatchEvent(new CustomEvent("portfolio-filter", { detail: filter }));
    const el = document.getElementById("portfolio");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section
      id="services"
      className="relative py-24 md:py-32 bg-[var(--surface)] overflow-hidden bp-overlay"
      data-testid="services-section"
    >
      <div className="relative z-10 max-w-[1440px] mx-auto px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
          className="mb-16 md:mb-24 max-w-3xl"
        >
          <div className="overline mb-4">{t.services.overline}</div>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-light text-white leading-[1.05]">
            {t.services.title}
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-[var(--border)]">
          {items.map(({ Icon, title, desc, num, filter }, i) => (
            <motion.button
              type="button"
              key={title}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: i * 0.08 }}
              onClick={() => onCardClick(filter)}
              className="group relative bg-[var(--surface)] p-8 md:p-10 hover:bg-[var(--bg)] transition-colors duration-500 cursor-pointer text-left rounded-none focus:outline-none focus:ring-2 focus:ring-white/40"
              data-testid={`service-card-${num}`}
            >
              <div className="flex items-start justify-between mb-12">
                <Icon size={40} strokeWidth={1} className="text-white/80 group-hover:text-white transition-colors" />
                <span className="text-xs tracking-widest text-[var(--text-muted)]">{num}</span>
              </div>
              <h3 className="font-display text-2xl font-medium text-white mb-4 leading-tight">{title}</h3>
              <p className="text-sm leading-relaxed text-[var(--text-muted)] mb-8">{desc}</p>
              <div className="flex items-center gap-2 text-xs uppercase tracking-widest text-white/60 group-hover:text-white transition-colors">
                <span className="w-8 h-px bg-current" />
                <ArrowUpRight size={16} />
              </div>
            </motion.button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
